import { formatDateTime } from '@/util/date';
import { DISPLAY_DATETIME } from '@/util/apiDatetime';

export function roundToMinute(timestampSeconds) {
  return Math.floor(timestampSeconds / 60) * 60;
}

export function formatRowDateTime(roundedTimestamp) {
  return formatDateTime(roundedTimestamp * 1000, DISPLAY_DATETIME);
}

// Gabungin seriesData per menit jadi satu baris. `keys` didefaultin '-' di tiap
// baris baru, lalu `assign(row, serie)` yang isi value sebenarnya per serie.
export function groupSeriesByMinute(seriesData, keys, assign) {
  const rows = {};
  seriesData.forEach((serie) => {
    const roundedTimestamp = roundToMinute(serie.timestamp);
    if (!rows[roundedTimestamp]) {
      const row = { timestamp: roundedTimestamp, datetime: formatRowDateTime(roundedTimestamp) };
      keys.forEach((key) => {
        row[key] = '-';
      });
      rows[roundedTimestamp] = row;
    }
    assign(rows[roundedTimestamp], serie);
  });
  return Object.values(rows);
}

// Passthrough buat tipe device yang gak butuh transform apa-apa selain nempelin datetime.
export function mapSeriesWithDatetime(seriesData, transform) {
  return seriesData.map((serie) => ({
    ...serie,
    datetime: formatRowDateTime(roundToMinute(serie.timestamp)),
    ...(transform ? transform(serie) : {}),
  }));
}
